import { Link } from "react-router-dom";
import { Dummy } from "../../pages/CommonPublicPages/Navbars/components/Dummy";

export function ThankYou() {
  return (
    <>
    <Dummy />
      <div className="bg-mainBg h-screen">
        <div className="flex justify-center">
          <div className="">
            <div className="flex justify-center">
              <img
                className="w-60"
                src="https://in.indeed.com/notifications/static/images/NotificationBell-6babc1.png"
                alt=""
              />
            </div>
            <div className="text-center">
              <h3>Thank You for completing all the steps!</h3>
              <p className="text-black mx-5 mt-3">
                Your Account has been created and now you're ready to post jobs.
              </p>
              <button className="a-button text-white w-72">
                Subscription Plan?
              </button>
              
                <Link to={"/employer-dashboard"}>
                <div className="text-blue-700 underline py-3">
                  or head to Dashboard?
                </div>
                </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
